import { SxProps, Theme } from "@mui/material/styles";

export const styles: Record<string, SxProps<Theme>> = {
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    pt: 1,
    pb: 1,
    userSelect: "none",
  },
  icon: (theme) => ({
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  }),
  expirationContainer: {
    alignItems: "center",
    flexDirection: { xs: "column", sm: "row", md: "column", lg: "row" },
    gap: { xs: 0, sm: 1.5, md: 0, lg: 1.5 },
    mt: 1,
  },
};
